import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnTools,
  columnCollectionDatasetLastAdded,
  columnCollectionDatasetCount,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import CollectionsTableRows from './CollectionsTableRows';
import CollectionsTableHeader from './CollectionsTableHeader';
import CollectionsFilters from '../containers/CollectionsFilters';
import CollectionsTableSettingsMenu from '../containers/CollectionsTableSettingsMenu';

const CollectionsTable = ({
  collections,
  readStatus,
  readErrors,
  category,
  total,
  pageCount,
  pageSize,
  currentPage,
  fetchData,
  canCreate,
  className,
  hideColumns,
  onCheckBoxClick,
  newCollectionCode,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnCollectionDatasetLastAdded,
    columnCollectionDatasetCount,
    columnTools,
  ],
}) => {
  const { items, pageNumber } = fitToPage(collections, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className={clsx('ReactTable', className)} ref={ref}>
      <TableWrapper sticky celled className="aridhia-collections-table" columns={columns}>
        <CollectionsTableHeader
          category={category}
          collections={items}
          columns={columns}
          hideColumns={hideColumns}
          readErrors={readErrors}
          readStatus={readStatus}
        >
          { readStatus === states.SUCCESS && !hideColumns && <CollectionsTableSettingsMenu category={category} />}
          <CollectionsFilters category={category} className="aridhia-table-filter" />
        </CollectionsTableHeader>
        <Table.Body>
          <CollectionsTableRows
            category={category}
            items={items}
            columns={columns}
            onCheckBoxClick={onCheckBoxClick}
          />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate={canCreate}
        currentPage={pageNumber}
        entity="collection"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="object group outline"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        url={codeUrl(urls.COLLECTION, newCollectionCode, '#')}
      />
    </div>
  );
};

export default CollectionsTable;
